import { namedValueLabel } from '../services/incidentLookup';
/**
 * Fallback labels matching Kokomo Incidents/lookup `statuses`.
 * Prefer live lookup values when available.
 */
export const FALLBACK_STATUS_LABELS = {
    0: 'Received',
    1: 'Scheduled',
    2: 'Active',
    3: 'Closed',
};
export function referralStatusLabel(status, statuses) {
    if (statuses?.length) {
        return namedValueLabel(statuses, status, 'Status');
    }
    return FALLBACK_STATUS_LABELS[status] ?? `Status ${status}`;
}
/** Visual tone for the status pill, keyed off the display label. */
export function referralStatusTone(label) {
    const name = label.trim().toLowerCase();
    if (name.includes('unable'))
        return 'unable';
    if (name.includes('scheduling'))
        return 'scheduling';
    if (name.includes('scheduled'))
        return 'scheduled';
    if (name.includes('received'))
        return 'received';
    if (name.includes('seen'))
        return 'seen';
    return 'neutral';
}
